<template>
    <v-card>
        <v-toolbar flat color="pink" dark>
            <v-toolbar-title>{{ trans('document-checklist.templates-title') }}</v-toolbar-title>
            <v-text-field v-model="filters.search" dense :label="trans('common.search')" prepend-icon="search" />
            <v-spacer></v-spacer>
            <v-btn color="success" @click="createNewTemplate" v-bind="{ loading: isLoading, disabled }"><v-icon
                    left>add</v-icon> Crea
                nuovo template</v-btn>
        </v-toolbar>
        <v-card-text>
            <h3>Lista dei template presenti:</h3>

            <data-table :filters.sync="filters" v-bind="{ headers, action: '/document-templates' }" ref="dataTable">

                <!-- Personalizzazione colonna "active" -->

                <template v-slot:item.customer_id="{ item }">
                    {{ item.customer ? item.customer.name : '' }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <!--<delete-btn :action="'/document-templates/:id'.replace(':id', item.id)"></delete-btn>-->

                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                        </template>

                        <v-list dense>
                            <v-list-item class="primary" dark @click="loadTemplate(item)">
                                <v-list-item-icon><v-icon>download</v-icon></v-list-item-icon>
                                <v-list-item-title>Carica template</v-list-item-title>
                            </v-list-item>
                            <v-divider />
                            <v-list-item class="amber darken-2" dark @click="updateTemplate(item)">
                                <v-list-item-icon><v-icon>edit</v-icon></v-list-item-icon>
                                <v-list-item-title>Aggiorna template</v-list-item-title>
                            </v-list-item>
                            <v-divider />
                            <v-list-item class="error" dark @click="deleteTemplate(item)">
                                <v-list-item-icon><v-icon>delete</v-icon></v-list-item-icon>
                                <v-list-item-title>Elimina template</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>



            </data-table>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" v-bind="{ loading: isLoading, disabled }" outlined color="secondary"><v-icon
                    left>close</v-icon>{{
                trans('common.close')
            }}</v-btn>
        </v-card-actions>
        <v-dialog persistent :value="!!confirmTemplate" max-width="600">
            <v-card>
                <v-card-title>Conferma caricamento template</v-card-title>
                <v-card-text>
                    Sono presenti dei documenti caricati, come devo agire?
                    <ul>
                        <li><strong>Unisci</strong> i file caricati con il template</li>
                        <li><strong>Sovrascrivi</strong> tutte le righe eliminando i file caricati</li>
                    </ul>
                </v-card-text>
                <v-card-actions>

                    <v-btn @click="confirmTemplate = null" outlined color="secondary">
                        <v-icon left>close</v-icon>{{ trans('common.cancel') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="_loadTemplate(confirmTemplate, false)" color="pink" dark>
                        <v-icon left>call_merge</v-icon> Unisci</v-btn>
                    <v-btn @click="_loadTemplate(confirmTemplate, true)" color="warning">
                        <v-icon left>published_with_changes</v-icon> Sovrascrivi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-if="editTemplate" :value="!!editTemplate" max-width="600">
            <v-card>
                <v-card-title>Modifica template</v-card-title>
                <v-card-text>
                    <v-form v-model="validEdit">
                        <v-text-field v-model="editTemplate.name"
                            v-bind="{ loading: isLoading, disabled, label: trans('Nome template') }"
                            :rules="editRules.name" />
                        <v-text-field v-model="editTemplate.description"
                            v-bind="{ loading: isLoading, disabled, label: trans('Descrizione template') }" />
                        <v-switch v-model="overwriteTemplateData" v-bind="{
                loading: isLoading,
                disabled,
                label: trans('Sovrascrivi checklist template'),
                hint: 'Se selezionato sovrascriverà la checklist del template con quella corrente, in caso contrario modificherà solo nome e descrizione.',
                persistentHint: true,
            }" />
                    </v-form>
                </v-card-text>
                <v-card-actions>

                    <v-btn v-bind="{ loading: isLoading, disabled }" @click="editTemplate = null" outlined
                        color="secondary">
                        <v-icon left>close</v-icon>{{ trans('common.cancel') }}</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn v-bind="{ loading: isLoading, disabled }" @click="confirmUpdate" color="primary">
                        <v-icon left>save</v-icon> Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-if="createTemplate" :value="!!createTemplate" max-width="600">
            <v-card>
                <v-card-title>Crea nuovo template</v-card-title>
                <v-card-text>
                    <v-form v-model="validEdit">
                        <v-text-field v-model="createTemplate.name"
                            v-bind="{ loading: isLoading, disabled, label: trans('Nome template') }"
                            :rules="editRules.name" />
                        <v-text-field v-model="createTemplate.description"
                            v-bind="{ loading: isLoading, disabled, label: trans('Descrizione template') }" />
                    </v-form>
                </v-card-text>
                <v-card-actions>

                    <v-btn v-bind="{ loading: isLoading, disabled }" @click="createTemplate = null" outlined
                        color="secondary">
                        <v-icon left>close</v-icon>{{ trans('common.cancel') }}</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn v-bind="{ loading: isLoading, disabled }" @click="confirmCreate" color="primary">
                        <v-icon left>save</v-icon> Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <error-snackbar v-model="error" />
    </v-card>
</template>

<script>
import { Vuelidator, Rule } from '../../../Vuelidator/index';

export default {
    props: {
        value: { type: Array, required: true, },
        disabled: { type: Boolean, default: false, },
        loading: { type: Boolean, default: false, },
    },
    data() {

        const validator = new Vuelidator({
            name: [Rule.required(), Rule.string(), Rule.min(3),],
        });
        const editRules = validator.getRules();

        return {

            filters: { search: '' },

            headers: [
                { "text": "Nome template", "value": "name", "filterable": true, "sortable": true },
                { "text": "Descrizione", "value": "description", "filterable": true, "sortable": true },
                { "text": "Num.documenti", "value": "documents_count", "filterable": false, "sortable": true },
                { "text": "Azioni", "value": "actions", "filterable": false, "sortable": false },
            ],
            editRules,

            confirmTemplate: null,

            editTemplate: null,
            validEdit: false,
            overwriteTemplateData: false,

            createTemplate: null,

            processing: false,
            error: null,
        };
    },
    computed: {
        isLoading() { return this.loading || this.processing; }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        loadTemplate(template) {
            //if (confirm(`Confermi di voler sostituire la lista documenti con quella presente nel template "${template.name}"?`)) {
            let hasFiles = this.value.find(e => e.done) !== null;
            console.warn(this.value, hasFiles);

            if (hasFiles) {
                this.confirmTemplate = template;
            } else {
                this._loadTemplate(template, true);
            }
            //this.$emit('load-template', template.data);
            //}
        },
        _loadTemplate(template, force) {
            console.log('_loadTemplate', template);
            let data = JSON.parse(JSON.stringify(template.data));//deep clone
            if (!force) {
                let old = this.value.filter(e => e.done);
                data = [...old, ...data];
            }

            this.$emit('load', data);
            this.confirmTemplate = null;
        },
        updateTemplate(template) {
            this.editTemplate = Object.assign({}, template);
            this.overwriteTemplateData = false;
        },
        async confirmUpdate() {

            const id = this.editTemplate.id;
            const data = {
                name: this.editTemplate.name,
                description: this.editTemplate.description,
            };


            if (this.overwriteTemplateData) {
                data.data = this.value;
            }


            this.processing = true;
            this.error = null;
            try {
                let r = await axios.patch(`/document-templates/${id}`, data);
                if (r.data?.result !== 'ok') {
                    throw r;
                }
                this.$refs.dataTable.refresh();
                this.editTemplate = null;
            } catch (e) {
                this.error = e;
            } finally {
                this.processing = false;
            }
        },
        async deleteTemplate(template) {
            if (confirm(trans('çommon.delete'))) {
                this.processing = true;
                try {
                    await axios.delete(`/document-templates/${template.id}`);
                } catch (e) {
                    this.error = e;

                }
                this.processing = false;
                this.$refs.dataTable.refresh();
            }
        },
        createNewTemplate() {
            this.createTemplate = {
                name: '',
                description: '',
            }
        },
        async confirmCreate() {
            ////todo
            const data = Object.assign({
                data: this.value,
            }, this.createTemplate);
            this.processing = true;
            try {
                await axios.post(`/document-templates`, data);
                this.createTemplate = null;
            } catch (e) {
                this.error = e;

            } finally {
                this.processing = false;
                this.$refs.dataTable.refresh();
            }
        }
    },

}
</script>